//getUserWoAssTask
import _axios from '../../../util/axios/AxiosConfig'

export function getDetail(key){
    return _axios({
        url: `/api/storeCheck/getDetail?id=${key}`,
        method: 'get'
    })
}

export function submit(data){
    return _axios({
        url: `/api/StoreCheck/submit`,
        method: 'post',
        data:data
    })
}
